import React, { Component } from "react";

class QuestionDisclaimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDisplayed: false,
    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleCloseDisclaimer);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleCloseDisclaimer);
  }

  //Closes question disclaimers
  handleCloseDisclaimer = (event) => {
    if (this.buttonRef && !this.buttonRef.contains(event.target)) {
      this.setState({ isDisplayed: false });
    }
  };

  render() {
    const { isDisplayed } = this.state;
    const { disclaimer } = this.props;

    const displayDisclaimer = (e) => {
      // added prevent default for knee disability to resolve issue 
      // where radio option was being selected when clicked; 
      // may be helpful in other situations
      e.preventDefault();
      e.stopPropagation();
      this.setState({ isDisplayed: !isDisplayed });
    };

    return (
      <div style={{display:'inline', marginLeft:'5px'}}>
        <img
          src="/imgs/app/info-circle.svg"
          alt="More info"
          width="20"
          height="20"
          style={{ cursor: "pointer", marginRight: "5px" }}
          ref={(node) => (this.buttonRef = node)}
          onClick={(e) => displayDisclaimer(e)}
        />
        {isDisplayed ? (
          <div
            style={{
              color: "grey",
              position: "absolute",
              zIndex: 9999,
              top: "5px",
              right: "30px",
              background: "whitesmoke",
              border: "1.5px solid grey",
              borderRadius: "10px",
              padding: "10px 5px 5px 5px",
              marginLeft: "10px",
              textAlign: "left",
              display: "inline",
              boxShadow: "0px 0px 4px black",
            }}
            className="option-disclaimer"
          >
            <p>{disclaimer}</p>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default QuestionDisclaimer;
